module.exports = __webpack_public_path__ + "img/banner_title.4abcf649.png";